import React from "react";
import { showAddressModal, showChooseShop } from "../../redux/actions";
import AddressInputModal from "../AddressInput/AddressInputModal.view";
import { useAppDispatch, useAppSelector } from "../../redux/hook";
import { ModalCard } from "@dishopsaas/design-system";
import { useParams } from 'react-router-dom';

export default function AddressModal() {
  const dispatch = useAppDispatch();
  const { addressModal } = useAppSelector(
    (state) => state.componentReducer
  );
  const { shopId } = useParams();
  const onClose = () => {
    dispatch(showAddressModal(false));
    dispatch(showChooseShop(false));
  };

  return (
    <ModalCard open={addressModal?.show} maxWidth={440} sxModal={{ padding: "0 20px" }}>
      <>
        <AddressInputModal
          shopId={shopId}
          onClose={onClose}
        />
      </>
    </ModalCard>
  );
}
